import React from 'react';
import Wetter from '../components/Wetter';
import './home.css'; // gleiche Styles wie bei Home verwenden

function WetterMuerzzuschlag() {
  return (
    <div
      className="home-container"
      role="main"
      aria-labelledby="wetter-muerzzuschlag-heading"
    >
      <div className="home-diagramm">
        <div className="wetter-container">
          <h1 id="wetter-muerzzuschlag-heading">WETTER</h1>
        </div>

        <Wetter ort="muerzzuschlag" />
      </div>
    </div>
  );
}

export default WetterMuerzzuschlag;
